<template>
    <iframe class="hl-legal-frame" frameborder="0" :src="url"/>
</template>

<script>
import { settingsMixin } from '@/utils/settings-mixin';

const LEGAL_BASE_URL = 'https://privacypolicy.tabgame.de/privacypolicy/webapp/';

// file name suffix of the hosted legal pages per language; other languages use the plain file name
const LANG_CODES = {
    en: process.env.VUE_APP_IMPRINT_LANG_CODE_EN,
    de: process.env.VUE_APP_IMPRINT_LANG_CODE_DE,
    fr: process.env.VUE_APP_IMPRINT_LANG_CODE_FR,
    nl: process.env.VUE_APP_IMPRINT_LANG_CODE_NL,
};

export default {
    mixins: [settingsMixin],
    props: {
        // page name on the legal server: 'imprint' or 'privacy_policy'
        kind: {
            type: String,
            required: true,
        },
    },
    computed: {
        // hosted page of this build in the user's language; no language falls back to German
        url() {
            const lang = this.userLanguage;
            const code = lang == null ? LANG_CODES.de : LANG_CODES[lang];
            return `${LEGAL_BASE_URL}${process.env.VUE_APP_APP_CUSTOM_ID}/${this.kind}${code || ''}.html`;
        },
    },
};
</script>

<style scoped>
.hl-legal-frame {
    display: block;
    width: 100%;
    height: 100%;
}
</style>
